import { TextLink } from '@palmetto/palmetto-components';

import { RECHECK_LICENSE_LINK_TEXT, getRecheckLicenseUrl } from '../../helpers/salesRepRecheck';

export function RecheckLicenseLink() {
  return (
    <TextLink href={getRecheckLicenseUrl()} target="_blank" rel="noopener noreferrer">
      {RECHECK_LICENSE_LINK_TEXT}
    </TextLink>
  );
}
